import { defineComponent as _defineComponent } from 'vue'
import FormContainer from "../shared/FormContainer.vue"
import { PropType, ref } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import Dropzone from "@/components/widgets/input/Dropzone.vue"
import { useUtilities } from "@/hooks/useUtilities"
import { ValidationObserver } from "vee-validate"
import { useNotification } from "@/hooks/useNotification"
import Modal from "@/components/widgets/common/Modal.vue"
import { useNewConsultantInputForm } from "../shared/useNewConsultantInputForm"
import OutlinedTextField from "@/components/fields/OutlinedTextField.vue"

type Experience = {
  id?: string
  otherCompany?: string
  jobTitle: string
  description: string
  startDate: string
  endDate: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceInfoForm',
  props: {
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  submitButtonText: {
    type: String,
    default: "Next",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
},
  emits: ["gotoNext", "gotoPrev", "change"],
  setup(__props, { emit }) {




const { formatDate, generateRand } = useUtilities()
const { addError } = useNotification()

const defaultForm: Experience = {
  jobTitle: "",
  startDate: "",
  description: "",
  endDate: "",
  otherCompany: "",
}

const form = ref<Experience>({
  ...defaultForm,
})

const experienceList = ref<Experience[]>([])

const observer = ref<InstanceType<typeof ValidationObserver> | null>(null)
const dropzone = ref<InstanceType<typeof Dropzone> | null>(null)

const showAddExperienceDialog = ref(false)

const onClose = () => {
  showAddExperienceDialog.value = false
  resetForm()
}

const onAddExperience = () => {
  showAddExperienceDialog.value = true
}

const { updateNewConsultantInput } = useNewConsultantInputForm()

const onSaveExperience = () => {
  const formValues = {
    ...form.value,
  }

  if (formValues.id) {
    const index = experienceList.value.findIndex((exp) => exp.id === formValues.id)
    if (index !== -1) {
      experienceList.value[index] = formValues
    }
  } else {
    experienceList.value.push({ ...formValues, id: generateRand(10) })
  }

  showAddExperienceDialog.value = false
  resetForm()

  updateNewConsultantInput({
    consultantWorkExperiencesAttributes: experienceList.value.map((experience) => ({
      ...experience,
      id: undefined,
    })),
  })

  emit("change", experienceList.value)
}

const onEditExperience = (experience: Experience) => {
  showAddExperienceDialog.value = true
  form.value = {
    ...experience,
  }
}

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return
  onSaveExperience()
}

const gotoNext = () => {
  if (experienceList.value.length < 1) {
    addError("Add at least one work experience to continue")
  } else {
    emit("change", experienceList.value)
    emit("gotoNext")
  }
}

const resetForm = () => {
  form.value = {
    ...defaultForm,
  }

  dropzone.value?.reset()

  observer.value?.reset()
}

return { __sfc: true,emit, formatDate, generateRand, addError, defaultForm, form, experienceList, observer, dropzone, showAddExperienceDialog, onClose, onAddExperience, updateNewConsultantInput, onSaveExperience, onEditExperience, onSubmit, gotoNext, resetForm, FormContainer, ValidationObserver, Modal, OutlinedTextField }
}

})